<app-mobile-nav [inverse]="true" [flow]="true">
  <span class="h4" *ngIf="data$ | async as data">{{ data.title }}</span>
</app-mobile-nav>

<div class="page__section l-wrapper _xs">
  <div class="card" *ngIf="data$ | async as data">
    <div class="card__head l-wrapper">
      <div class="card__title h1">{{ data.title }}</div>
    </div>
    <div *ngIf="data.content || data.customCode; else emptyMessage">
      <div class="card__body l-wrapper editor"
           *ngIf="data.content" [innerHTML]="(data.content) | safeHTML"></div>
      <div class="card__body l-wrapper editor"
           *ngIf="data.customCode" [innerHTML]="(data.customCode) | safeHTML"></div>
    </div>
  </div>


  <div class="spinner-wrap" *ngIf="isLoading$ | async">
    <mat-spinner color="accent"></mat-spinner>
  </div>
</div>

<ng-template #emptyMessage>
  <div class="card__body l-wrapper">
    <span class="h4" i18n="@@EmptyDataMessage">So far there is nothing</span>
  </div>
</ng-template>
